import { isEmpty } from 'ramda'

export const omitEmptyObject = object =>
  isEmpty(object) ? null : object
